
import "./SetLogingPopup.scss";
import UserContext from "../../../../services/context/userContext";
import { useContext, useEffect, useState } from "react";
import Input from "../../../_default/Input";
import { getLogsHistory } from "../../../../services/firebase/firestore/getData";
import { useParams } from "react-router-dom";
import Header from "../../../../components/_default/Header"
import Loading from "../../../_default/Loading";
// import { Dropdown as SemanticDrop } from "semantic-ui-react";
// import {Dropdown as GenderDropdown}   from "../../../../components/_default/DropDown";
export default function SetLogingPopup({ set_exercise_history_tab,button, onCancel, savePopup, time, editMode }) {
    const user = useContext(UserContext);
    let [historyData, setHistoryData] = useState([])
    let [loading, setLoading] = useState(true)
    const [clicktab,setClick]=useState(set_exercise_history_tab)
    const isAdmin = (true);
    // let {id}=useParams()
    let path = window.location.href
    let id = path.split("/")
    let exerciseId = id[id.length - 1];
    let clientId = localStorage.getItem("client_id")
    // console.log("clint page",setClientPages(...clientPages ,{name:"Exercise History",icon:"chat"}),clientPages )
    useEffect(() => {
        console.log("paramid", id[id.length - 1], clientId)
        localStorage.setItem("tabIndex",JSON.stringify(5))
        getLogsHistory(clientId, exerciseId, res => {
            console.log("res", res)
            if (res) {
                setLoading(false)

                setHistoryData(res.history)
            } else {
                setLoading(false)

            }
        })
    }, [loading])
    //   function toggleCalculator() {
    //     if (showCalculator) {
    //       setShowCalculator(false);
    //     } else {
    //       setShowCalculator(true);
    //     }

    //     //   const [showCalculator, setShowCalculator] = useState(false);
    //   }

    return (
        <>

            <div className="c-page-wrapper " style={{ flexFlow: "column" }}>
                {editMode ? "" : <Header set_exercise_history_tab={setClick} exerciseHistoryTab={true} title="Set Logging" subtitle={true} />}
                <div className="c-page-wrapper-mealplan">
                    {
                        loading ?
                            <>
                                <Loading />
                            </> :
                            historyData.length > 0 ?

                                historyData.map(function (data, i) {
                                    return (
                                        <div className="calorie-count" key={data.date}>
                                            <h2 className="date-heading" >Date:{data.date}</h2>
                                            {/* <label>{data.date}</label> */}
                                            {/* <label>Set {i+1}</label> */}
                                            {

                                                data.repetitions.map(function (rep, j) {
                                                    return (
                                                        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                                                            <span className="set-heading" >Set {j + 1} </span>
                                                            <div className="calorie-settings" style={{ justifyContent: "space-between", width: "73%" }}>
                                                                <div className="loging-input-block" style={{ marginRight: "7px" }}>

                                                                    <label className="loging-input-label">Repetitions</label>
                                                                    <input className="loging-inputs" value={rep} />
                                                                </div>

                                                                <div className="loging-input-block" style={{ marginRight: "7px" }}>

                                                                    <label className="loging-input-label">Resistance</label>
                                                                    <input className="loging-inputs" value={data.weight[j]} />
                                                                </div>

                                                            </div>

                                                            <div className="calorie-settings" style={{ width: "73%", justifyContent: "space-between", marginTop: "5px", marginBottom: "5px" }}  >

                                                                <div className="loging-input-block" style={{ marginTop: "7px" }}>

                                                                    <label className="loging-input-label">RIR</label>
                                                                    <input className="loging-inputs" value={data.rirs[j]} />
                                                                </div>

                                                                <div className="loging-input-block" style={{ marginRight: "7px" }}>

                                                                    <label className="loging-input-label">RPE</label>
                                                                    <input className="loging-inputs" value={data.rpes[j]} />
                                                                </div>

                                                            </div >
                                                            <div className="loging-input-block" style={{}}>

                                                                <label className="loging-input-label">Notes</label>

                                                                <textarea className="loging-notes" value={data.notes[j]}></textarea>

                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {/* {
                                    data.weight.map(function(weight,j){
                                        return(
                                           <label>weight:{weight}</label> 
                                        )
                                    })
                                } */}
                                        </div>
                                    )

                                }) : <span style={{ fontSize: "20px" }}>Not any set Logged</span>

                    }

                </div>
            </div>

        </>
    )
}